<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- Microphone body -->
    <path
      d="M15 7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7V11C9 12.6569 10.3431 14 12 14C13.6569 14 15 12.6569 15 11V7Z"
      :fill="fill"
      :stroke="stroke"
      stroke-width="1.6"
    />
    <!-- Stand vertical -->
    <path
      d="M12 16V19"
      :stroke="stroke"
      stroke-width="1.6"
      stroke-linecap="round"
    />
    <!-- Stand horizontal -->
    <path
      d="M8 19H16"
      :stroke="stroke"
      stroke-width="1.6"
      stroke-linecap="round"
    />
    <!-- Microphone arc -->
    <path
      d="M6 10V11C6 13.76 8.24 16 11 16H13C15.76 16 18 13.76 18 11V10"
      :stroke="stroke"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <!-- Play arrow -->
    <path
      d="M19 17L22 18.5L19 20"
      :stroke="stroke"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
defineProps({
  fill: {
    type: String,
    default: 'none'
  },
  stroke: {
    type: String,
    default: '#81B0E1'
  }
});
</script>
